import { render, staticRenderFns } from "./InDmAvatar.vue?vue&type=template&id=6ad21a62&scoped=true"
import script from "./InDmAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./InDmAvatar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InDmAvatar.vue?vue&type=style&index=0&id=6ad21a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad21a62",
  null
  
)

export default component.exports